<template>
  <div class="cxdj-container">
    <AddEdit :visible.sync="showEdit" :edit-data="currentEditData" @closeDialog="closeDialog" ref="addEdit" />
    <DetailDialog :visible.sync="showDetail" :detail-data="currentDetailData" @closeDialog="closeDetailDialog" ref="detail" />
    <div class="search-container">
    <!-- 搜索框 -->
    <el-input
      v-model="searchKey"
      placeholder="搜索产品名称或地点..."
      class="search-box"
      @keyup.enter.native="handleSearch"
    />

    <el-button
    type="primary"
    icon="el-icon-plus"
    @click="handlePublish"
  >
    发布
  </el-button>
  </div>

    <!-- 产品列表表格 -->
    <el-table
      :data="productList"
      style="width: 100%"
      stripe
      class="product-table"
    >
      <el-table-column prop="cropName" label="作物名称" width="180" />
      <el-table-column label="产品图片" width="120">
        <template #default="{ row }">
          <img
            :src="row.productImage"
            style="width:60px; height:60px; object-fit:cover; border-radius:4px"
            alt="产品图片"
          />
        </template>
      </el-table-column>
      <el-table-column label="类型" width="100">
        <template #default="{ row }">
          <el-tag :type="row.type == 2 ? 'success' : 'warning'">
            {{ row.type == 2 ? '供应' : '求购' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="数量" width="120">
        <template #default="{ row }">{{ row.num }}{{ row.unit }}</template>
      </el-table-column>
      <el-table-column label="价格" width="120">
        <template #default="{ row }">{{ row.price }}</template>
      </el-table-column>
      <el-table-column prop="address" label="地址" />
      <el-table-column prop="createTime" label="发布时间" width="180" />
      <el-table-column label="操作" width="220">
        <template #default="{ row }">
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button type="text" class="delete-btn" @click="handleDelete(row)">删除</el-button>
          <el-button type="text" @click="handleView(row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        layout="prev, pager, next"
        @current-change="handlePageChange"
      />
    </div>
  </div>


</template>



<script>
import { getSupplyOrderList, getProductCategoryTree,
   deleteSupplyOrder } from '@/api/supplyOrder';

import AddEdit from './addEdit.vue';
import DetailDialog from './detail.vue';

export default {

  components: {
    AddEdit,
    DetailDialog
  },
  data() {
    return {
      baseUrl: window.globalUrl.HOME_API,
      activeMainTab: 'supply', // 供应/求购切换
      activeCategory: 'all',   // 当前选中分类
      searchKey: '',           // 搜索关键词
      categoryList: [],        // 分类数据
      productList: [],         // 产品列表
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      hasMore: false,
      dialogVisible: false,
      editDialogType: 'edit',
      showEdit: false,
      currentEditData: {},
      showDetail: false,
      currentDetailData: {},
    }
  },
  mounted() {
    this.loadCategories()
    this.loadProducts()
  },
  methods: {
    // 加载产品分类
    async loadCategories() {
      const { data } = await getProductCategoryTree()
      this.categoryList = data.filter(item => item.parentId === -1) // 只取一级分类
    },

    formatTime(timeStr) {
      if (!timeStr) return '';
      const now = Date.now();
      const time = new Date(timeStr).getTime();
      const diff = now - time;

      // 时间差计算
      const minute = 60 * 1000;
      const hour = minute * 60;
      const day = hour * 24;
      const month = day * 30;

      if (diff < minute) {
        return '刚刚';
      } else if (diff < hour) {
        return `${Math.floor(diff / minute)}分钟前`;
      } else if (diff < day) {
        return `${Math.floor(diff / hour)}小时前`;
      } else if (diff < month) {
        return `${Math.floor(diff / day)}天前`;
      }

      // 超过30天显示完整日期
      const date = new Date(timeStr);
      return `${date.getFullYear()}-${(date.getMonth()+1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    },

     handlePageChange(newPage) {
        this.currentPage = newPage;
        this.loadProducts();
        window.scrollTo(0, 0);  // 可选：切换后滚动到顶部
      },

    // 加载产品列表
    async loadProducts() {
      this.loading = true
      try {
        const params = {
          productCategoryId: this.activeCategory === 'all' ? '' : this.activeCategory,
          keyword: this.searchKey,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          allFlag: '1'
        }

        const { data } = await getSupplyOrderList(params)

        //处理获取的数据
        if (data.records != null && data.records.length > 0) {
          data.records.forEach(item => {
            // 处理图片数据
            item.productImage = item.img
              ? (() => {
                  try {
                    const imgs = JSON.parse(item.img);
                    console.log("imgs", imgs);
                    return Array.isArray(imgs)
                      ? this.baseUrl + 'admin/file/get?ossFilePath=' + imgs[0].url
                      : this.baseUrl + 'admin/file/get?ossFilePath=' + item.icon;
                  } catch {
                    return this.baseUrl + 'admin/file/get?ossFilePath=' + item.icon;
                  }
                })()
              : this.baseUrl + 'admin/file/get?ossFilePath=' + item.icon;
          })
        }
        console.log("item数据", data.records);
        this.productList = data.records

        this.hasMore = data.current < data.pages
        this.total = data.total
      } finally {
        this.loading = false
      }
    },

    // 切换主Tab
    handleMainTabChange() {
      this.resetList()
    },

    // 切换分类
    handleCategoryChange() {
      this.resetList()
    },

    // 搜索处理
    handleSearch() {
      this.resetList()
    },

    // 加载更多
    loadMore() {
      this.currentPage++
      this.loadProducts()
    },

    // 重置列表
    resetList() {
      this.currentPage = 1
      this.productList = []
      this.loadProducts()
    },
    handleEdit(row) {
      this.currentEditData = row
      console.log(this.currentEditData, '查看row是什么')
      this.showEdit = true
    },
    // 关闭弹框
    closeDialog() {
      this.showEdit = false;
    },
    closeDetailDialog() {
      this.showDetail = false;
    },
    handlePublish() {
      this.currentEditData = null
      this.showEdit = true;
    },
    async handleDelete(row) {
      // 删除逻辑
      console.log('删除', row.id);
       try {
          await this.$confirm('确定删除该需求吗？', '提示', {
            type: 'warning',
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          });

          const res = await deleteSupplyOrder({
            id: row.id
          });

          if (res.code == 0) {
            this.$message.success('删除成功');
            this.loadProducts(); // 刷新列表

            // 处理最后一页最后一条数据删除的情况
            if (this.productList.length === 1 && this.currentPage > 1) {
              this.currentPage -= 1;
            }
          }
        } catch (error) {
          if (error !== 'cancel') {
            console.error('删除失败:', error);
            this.$message.error('删除失败：' + (error.message || '服务器异常'));
          }
        }
    },
    handleView(row) {
      // 查看详情逻辑
      this.currentDetailData = row
      this.showDetail = true
    }


  }
}
</script>

<style lang="less" scoped>
.cxdj-container {
  padding: 20px;
  .el-tabs {
    margin-bottom: 20px;
  }
  .search-box {
    width: 800px;
    margin: 20px 0;
  }
  .product-card {
    margin-bottom: 24px;
    :deep(.el-card__body) {
      padding: 20px;
      height: 180px;
      display: flex;
      flex-direction: column;
    }

  .card-content {
    display: flex;
    gap: 20px;
    padding: 15px;

    .product-image {
      width: 60px;
      height: 60px;
      object-fit: cover;
      border-radius: 4px;
    }

    .product-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      h4 {
        margin: 0 0 8px 0;
        font-size: 16px;
        line-height: 1.4;
      }

      p {
        margin: 4px 0;
        font-size: 13px;

        &.price {
          color: #f56c6c;
          font-weight: 600;
          font-size: 15px;
        }

        &.stock {
          color: #67c23a;
        }
      }
    }
  }
}
  .load-more {
    text-align: center;
    margin-top: 20px;
  }
}

.header-line {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  h4 {
    margin: 0;
    font-size: 16px;
  }

  .el-tag {
    border: none;
    &.supply-tag {
      background: #67c23a;
      color: white;
    }
    &.demand-tag {
      background: #e6a23c;
      color: white;
    }
  }

  .num {
    font-size: 14px;
    color: #606266;
  }
}

.bottom-line {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .price {
    color: #f56c6c;
    font-weight: 500;
    margin: 0;
  }

}

.time {
  font-size: 12px;
  color: #909399;
  margin-left: 10px;
}

.bottom-info {
  width: 100%;
  margin-top: 12px;
  .info-item {
    display: flex;
    align-items: baseline;
    margin-bottom: 8px;
    font-size: 13px;
    .price {
      color: #c89020;
      font-weight: 500;
    }
    .label {
      color: #666;
      min-width: 45px;
    }
    .value {
      color: #333;
      flex: 1;
      word-break: break-all;
    }
  }
}
.delete-btn {
  color: #ff4d4f;
  margin: 0 8px;
}

.search-container {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  /deep/ .el-input__inner {
    border-radius: 20px;
    padding-right: 40px;
  }

  .el-button {
    border-radius: 20px;
    padding: 12px 25px;
    margin-left: 60px;
  }
}

</style>

